import { render, staticRenderFns } from "./DocusignAddAdditionalDocumentSignTab.vue?vue&type=template&id=7224855c&"
import script from "./DocusignAddAdditionalDocumentSignTab.vue?vue&type=script&lang=ts&"
export * from "./DocusignAddAdditionalDocumentSignTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports